import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';

@Injectable()
export class MsvfileService {
  readonly rootUrl = AppSettings.webApiURL;

  constructor(public httpClient: HttpClient) { }

  getCustomerDDL() {
    return this.httpClient.get(`${this.rootUrl}/api/MSVFileAPI/GetListCustomerDDL`);
  }
  getReport(customerId: string, fromDate: Date, toDate: Date) {
    let dateFromFormat: string = '';
    let dateToFormat: string = '';
    dateFromFormat = fromDate ? fromDate.toDateString() : '';
    dateToFormat = toDate ? toDate.toDateString() : '';
    return this.httpClient.get(`${this.rootUrl}/api/MSVFileAPI/GetReport?customerId=${customerId}&fromDate=${dateFromFormat}&toDate=${dateToFormat}`);
  }
  getDownloadFile(fileName: string, fileId: number, customerId: string) {
    return this.httpClient.get(`${this.rootUrl}/api/MSVFileAPI/GetDownloadFile?fileName=${fileName}&fileId=${fileId}&customerId=${customerId}`, { responseType: 'blob' });
  }
  getDownloadXmlFile(fileName: string, fileId: number, customerId: string) {
    return this.httpClient.get(`${this.rootUrl}/api/MSVFileAPI/GetDownloadXmlFile?fileName=${fileName}&fileId=${fileId}&customerId=${customerId}`, { responseType: 'blob' });
  }
  statusUpdate(fileId: number) {
    return this.httpClient.put(`${this.rootUrl}/api/MSVFileAPI/Put`, fileId);
  }
  prepareData(fileId: number) {
    return this.httpClient.get(`${this.rootUrl}/api/MSVFileAPI/PrepareData?fileId=${fileId}`);
  }
  setDataCompletitions(fileLoadDataResult: any) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/MSVFileAPI/PostCompleteData`, fileLoadDataResult, { headers });
  }
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/service/msvfile.service.ts